import Component from './TikTokPostGrid.vue'
export default Component
